import { defineStore } from "pinia";
import { readonly, ref } from "vue";
import { Toast } from "@/types/toast";
import axios, { AxiosError } from "axios";

export const useToastNotificationStore = defineStore(
  "toastNotificationStore",
  () => {
    const _notifications = ref<Toast[]>([]);
    const notifications = readonly(_notifications);

    async function pushNotification(
      toast: Omit<Toast, "id">,
      hideAfter = 4000
    ): Promise<void> {
      const now = Date.now();
      _notifications.value.push({
        id: now.valueOf(),
        ...toast,
      });

      setTimeout(() => removeNotification(now.valueOf()), hideAfter);
      await new Promise((resolve) => setTimeout(resolve, 5));
    }

    function removeNotification(id: number) {
      _notifications.value = _notifications.value.filter((n) => n.id !== id);
    }

    async function createNotificationFromMessage(message: string) {
      await pushNotification({
        type: "success",
        text: message,
      });
    }

    async function createNotificationsFromApi(e: unknown) {
      if (!axios.isAxiosError(e)) {
        return;
      }
      if (e.code === AxiosError.ERR_BAD_REQUEST) {
        const errors = e.response?.data.errors;
        const messages: string[] = [];
        if (!errors) {
          messages.push(e.response?.data.message ?? e.message);
        } else {
          for (const [, value] of Object.entries(errors)) {
            if (Array.isArray(value)) {
              value.map((message) => messages.push(message));
            }
          }
        }
        for (const message of messages) {
          await pushNotification({
            type: "error",
            text: message,
          });
        }
      }
    }

    return {
      notifications,
      pushNotification,
      removeNotification,
      createNotificationsFromApi,
      createNotificationFromMessage,
    };
  }
);
